var _jsxFileName = "/home/runner/_work/smpackages/smpackages/packages/webassets/src/components/Footer/TrusteSeals/index.tsx",
  _this = this;
import React, { useContext } from 'react';
import { Box } from '@wds/box';
import { getClientEnvironmentDetails } from '@sm/utils';
import useStyles from './useStyles';
import { useTrusteSealsQueryQuery } from './TrusteSeals.generated';
import DirectDebitLogo from './DirectDebitLogo';
import SepaLogo from './SepaLogo';
import BBBLogo from './BBBLogo';
import TrustedShop from './TrustedShop';
import { SMFooterContext } from '../SMFooterContext';
var showTrustedShopSeal = function showTrustedShopSeal(lang, country) {
  if (['DE', 'AT', 'CH'].includes(country) && lang === 'de') {
    return true;
  }
  return false;
};
var handleContextMenuClick = function handleContextMenuClick() {
  // eslint-disable-next-line no-alert
  alert('Copying Prohibited by Law - TrustedSite is a Trademark of TrustedSite, LLC');
  return false;
};
var FooterSeals = function FooterSeals() {
  var _useTrusteSealsQueryQ = useTrusteSealsQueryQuery(),
    loading = _useTrusteSealsQueryQ.loading,
    error = _useTrusteSealsQueryQ.error,
    data = _useTrusteSealsQueryQ.data;
  if (loading) return null;
  if (error) {
    console.error("An error occured with the graph query: ".concat(error));
  }
  var recentInvoice = data && data.user && data.user.team && data.user.team.billing && data.user.team.billing.recentInvoice || {};
  var paymentMethod = recentInvoice.paymentMethod,
    paymentMethodSubtype = recentInvoice.paymentMethodSubtype;
  return paymentMethod === 'DIRECT_DEBIT' ? /*#__PURE__*/React.createElement(Box, {
    m: 2,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 5
    }
  }, paymentMethodSubtype === 'GOCARDLESS_SEPA_DD' ? /*#__PURE__*/React.createElement(SepaLogo, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 9
    }
  }) : /*#__PURE__*/React.createElement(DirectDebitLogo, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 9
    }
  })) : null;
};
var TrusteSeals = function TrusteSeals() {
  var _useContext = useContext(SMFooterContext),
    _useContext$lang = _useContext.lang,
    lang = _useContext$lang === void 0 ? '' : _useContext$lang,
    _useContext$country = _useContext.country,
    country = _useContext$country === void 0 ? '' : _useContext$country,
    isUserAuthenticated = _useContext.isUserAuthenticated,
    isEUDC = _useContext.isEUDC;
  var _useStyles = useStyles(),
    trustedSeal = _useStyles.trustedSeal;
  var _getClientEnvironment = getClientEnvironmentDetails(),
    isBrowser = _getClientEnvironment.isBrowser;
  return /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexAlign: "center",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Box, {
    mr: 2,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("a", {
    title: "Click to verify BBB accreditation and to see a BBB report.",
    href: "https://www.bbb.org/us/ca/san-mateo/profile/market-survey/surveymonkey-1116-876628",
    rel: "noopener noreferrer",
    target: "_blank",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(BBBLogo, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 78,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement(Box, {
    m: 2,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 81,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("a", {
    rel: "noopener noreferrer",
    target: "_blank",
    title: "View TrustedSite Certification",
    href: "https://www.trustedsite.com/verify?host=".concat(isEUDC ? 'eu' : 'www', ".surveymonkey.com"),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 82,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("img", {
    className: trustedSeal,
    alt: "TrustedSite helps keep you safe from identity theft, credit card fraud, spyware, spam, viruses and online scams",
    src: "https://cdn.ywxi.net/meter/surveymonkey.com/202.svg",
    onContextMenu: handleContextMenuClick,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 90,
      columnNumber: 11
    }
  }))), !!(isUserAuthenticated && isBrowser) && /*#__PURE__*/React.createElement(FooterSeals, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 98,
      columnNumber: 48
    }
  }), showTrustedShopSeal(lang, country) && /*#__PURE__*/React.createElement(TrustedShop, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 99,
      columnNumber: 46
    }
  }));
};
export default TrusteSeals;
//# sourceMappingURL=index.js.map